/**
 * Transforme le nom d'un exercice fiscal pour l'affichage localisé.
 * Détecte le pattern "Exercice XXXX" et remplace le préfixe selon la langue.
 * Si le nom ne correspond pas au pattern, il est retourné tel quel.
 */
const FY_PREFIXES = {
  de: "Geschäftsjahr",
  fr: "Exercice",
};

export const displayFyName = (name, language) => {
  if (!name) return name;
  const match = name.match(/^Exercice\s+(\d{4})$/);
  if (!match) return name;
  const prefix = FY_PREFIXES[language] ?? FY_PREFIXES.fr;
  return `${prefix} ${match[1]}`;
};
